export default __webpack_public_path__ + "static/media/uploader-medtronic-2.4cff5dfd.png";